import { from, Observable, firstValueFrom } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { TolgeeService } from './tolgee.service';
import { BcmTenantService } from '@modules/bcm/bcm-tenant.service';
import { BcmService } from '@modules/bcm/bcm.service';
import { TenantApiService } from '@bcmApiServices/tenant.api-service';
import { getUserLanguagePreference } from '@modules/bcm/@shared/utils/user-language-preference.util';
import { BCM_DEFAULT_LANGUAGE } from '@modules/bcm/@shared/utils/multilingualism-license.util';
import { getTenantIdFromUrl } from '@modules/bcm/@shared/utils/tenant-context.util';
import { Location } from '@angular/common';

async function applyStoredUserLanguage(
    bcmTenantService: BcmTenantService,
    tenantApiService: TenantApiService,
    bcmService: BcmService,
    location: Location,
): Promise<void> {
    const preferred = getUserLanguagePreference();

    // getUserLanguagePreference liefert bei gespeichertem 'de' truthy zurueck - ohne diesen
    // Zweig laeuft der ganze Ablauf auch fuer Nutzer, deren Sprache ohnehin die Standardsprache ist
    if (!preferred || preferred === BCM_DEFAULT_LANGUAGE) {
        return;
    }

    // Im Mandanten-Kontext setzt BcmNavigationResolver die Sprache aus den Nutzereinstellungen.
    // Die Mandantenliste hier vorzuladen waere reines Over-Fetching (#6847) - GET /tenants
    // liefert jede Mandantenzeile inklusive entschluesselter Bankverbindung.
    if (getTenantIdFromUrl(location) !== 0) {
        return;
    }

    // Ohne aktiven Mandanten entscheidet die Liste ueber das Sprachmodul-Recht. BcmService
    // haelt sie nur im Speicher, beim Bootstrap ist sie also immer leer.
    // Fehler muessen hier sterben: eine Exception bricht den APP_INITIALIZER ab und der
    // Nutzer bekommt eine leere Seite statt der App in der Standardsprache.
    try {
        bcmService.setAccessibleTenants(await firstValueFrom(tenantApiService.getAll()));
        await bcmTenantService.applyStoredUserLanguageIfNeeded();
    } catch {
        return;
    }
}

export function translationInitializer(
    tolgeeService: TolgeeService,
    bcmTenantService: BcmTenantService,
    tenantApiService: TenantApiService,
    bcmService: BcmService,
    location: Location,
): Observable<boolean> {
    return from(tolgeeService.run()).pipe(
        switchMap(() => from(applyStoredUserLanguage(
            bcmTenantService,
            tenantApiService,
            bcmService,
            location,
        ))),
        map(() => true),
    );
}
